import { useState } from "react";
import { api } from "../../helpers/api";
import { ShowToast } from "../../components/toast";
import { Button } from "../../components/Button";
import { PopupModal } from "../../components/PopupModal";

export function ConfirmDelete({
  onClose,
  userId,
  refetch,
  name,
}: {
  onClose: () => void;
  userId: string;
  refetch: () => void;
  name: string;
}) {
  const [isLoading, setIsLoading] = useState(false);
  const handleDelete = () => {
    setIsLoading(true);
    api
      .deleteUser(userId)
      .then(() => {
        onClose();
        ShowToast({
          message: "User deleted successfully",
          type: "success",
        });
        refetch && refetch();
        setIsLoading(false);
      })
      .catch(() => {
        ShowToast({
          message: "Failed to delete user",
          type: "error",
        });
        setIsLoading(false);
      });
  };

  return (
    <PopupModal
      onClose={onClose}
      contentClassName="w-[500px] mx-auto"
      containerClassName="!z-[100]"
    >
      <p className="text-lg leading-[28.8px] poppins">
        Are you sure you want to delete {name}'s account? All of their data will
        be permanently removed.
      </p>
      <div className="flex flex-row gap-4 ml-auto">
        <Button variant="outline" className="px-8" onClick={onClose}>
          No, go back
        </Button>
        <Button
          className="px-8 text-[1rem] !bg-[#FDCDCD] !text-[#D30000]"
          onClick={handleDelete}
          loading={isLoading}
          variant="primary"
        >
          Yes delete
        </Button>
      </div>
    </PopupModal>
  );
}

export function ConfirmBlock({
  onClose,
  userId,
  refetch,
  name,
}: {
  onClose: () => void;
  userId: string;
  refetch: () => void;
  name: string;
}) {
  const [blocking, setBlocking] = useState(false);
  const handleBlock = () => {
    setBlocking(true);
    api
      .updateUser(userId, false)
      .then(() => {
        setBlocking(false);
        onClose();
        ShowToast({
          message: "User deactivated successfully",
          type: "success",
        });
        refetch && refetch();
      })
      .catch((err) => {
        setBlocking(false);
        ShowToast({
          message: err.response.data.message || `Failed to deactivate user`,
          type: "error",
        });
      });
  };

  return (
    <PopupModal
      onClose={onClose}
      contentClassName="w-[500px] mx-auto"
      containerClassName="!z-[100]"
    >
      <p className="text-lg leading-[28.8px] poppins">
        Are you sure you want to deactivate {name}'s account? They will not be
        able to access their account until it is reactivated.
      </p>
      <div className="flex flex-row gap-4 ml-auto w-full">
        <Button
          variant="outline"
          className="px-8 flex-1"
          onClick={onClose}
          disabled={blocking}
        >
          No, go back
        </Button>
        <Button
          className="px-8 text-[1rem] flex-1 !bg-[#FDCDCD] !text-[#D30000]"
          onClick={handleBlock}
          loading={blocking}
          variant="primary"
        >
          Yes deactivate
        </Button>
      </div>
    </PopupModal>
  );
}
